export const addDataToStore = (key, data) => {
    return {
        type: key,
        data: data,
    };
};
